import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { useState } from "react";
import { Form } from "react-bootstrap";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";
import Translate from "src/components/Translate";
import constants from "src/constants";
import translate from "src/functions/translate";
import { sFormControl } from "src/styles/sFormControl.module.scss";
import { sFormLabel } from "src/styles/sFormLabel.module.scss";
import { sGiftSection } from "src/styles/sGiftSection.module.scss";
import { sNote } from "src/styles/sNote.module.scss";

type Props = {
  giftDisabled: boolean;
  gift: boolean;
  setGift: (setGift: boolean) => void;
  giftMessage: string;
  setGiftMessage: (setGiftMessage: string) => void;
};

const GiftSection = ({
  gift,
  setGift,
  giftDisabled,
  giftMessage,
  setGiftMessage,
}: Props) => {
  const { locale: lang } = useRouter();
  const [count, setCount] = useState(0);

  const recalculate = (e) => {
    setGiftMessage(e.currentTarget.value);
    setCount(e.target.value.length);
  };

  return (
    <div
      className={composeClassNames([sGiftSection, giftDisabled && "disabled"])}
    >
      <div className="gift-section-header">
        <Form.Check>
          <Form.Check.Input
            type={`checkbox`}
            checked={gift}
            onChange={() => {
              setGift(!gift);
            }}
            id={`gift`}
            disabled={giftDisabled}
          />
          <Form.Check.Label htmlFor={`gift`}>
            <Heading
              type="h5"
              title={
                <>
                  🎁 <Translate tKey="I would like to gift my loved ones" />
                </>
              }
              style={{ color: constants.Theme.white }}
            />
          </Form.Check.Label>
        </Form.Check>
        {giftDisabled && (
          <Paragraph size="sm">
            <Translate tKey="It is currently not possible to give courses, classes or streams; if you have them in your cart, you will be not able to give." />
          </Paragraph>
        )}
      </div>
      {gift && (
        <div className="gift-section-content">
          <Paragraph size="xn">
            <strong>
              <Translate tKey="You can currently give a gift card or subscription." />
            </strong>{" "}
            <Translate tKey="To give, just have the option to Give checked and fill in the wish. Within 24 hours, we will send you an email with the gift card in PDF containing the QR code and coupon. Your recipient can then scan the QR code and the system will automatically put your gift and coupon in their basket. After confirmation and possibly entering personal data, she will be able to enjoy your gift. The coupon can be used for manual content input and discount." />
          </Paragraph>
          <Form.Group>
            <Form.Label className={sFormLabel}>
              <Translate tKey="Your wish for a gift card" />
            </Form.Label>
            <Form.Control
              as="textarea"
              className={sFormControl}
              id="giftMessage"
              name="giftMessage"
              maxLength={255}
              onChange={recalculate}
              rows={4}
              value={giftMessage}
            />
            <Form.Text className={sNote}>
              {translate(
                "Your current wish length %ACTUAL_LENGTH%/255 characters.",
                lang
              ).replace("%ACTUAL_LENGTH%", count)}
            </Form.Text>
          </Form.Group>
        </div>
      )}
    </div>
  );
};

export default GiftSection;
